import { faBars } from "@fortawesome/pro-regular-svg-icons";
import type { HTMLAttributes } from "react";

import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import * as styles from "./SidebarToggle.styles";

interface Props extends HTMLAttributes<HTMLButtonElement> {
  "aria-label": string;
}

const SidebarToggle = ({ ...rest }: Props) => {
  const { isEmerson } = useSharedGlobalConfig();
  const sidebarToggle = [styles.sidebarToggle, isEmerson && styles.EmersonSidebarToggle];
  const hamburgerStyle = [styles.hamburger, isEmerson && styles.EmersonNavBurger];

  return (
    <button css={sidebarToggle} {...rest}>
      <FontAwesomeIcon css={hamburgerStyle} icon={faBars} />
    </button>
  );
};

export { SidebarToggle };
